import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';

const { getUsername, isBrand, isShopper, getDefaultCuratorGroup } = require('../../Helpers/user_helpers');
const { getLinkToShopForCuratorGroup } = require('../../Helpers/shop_helpers');

const RootRedirect = props => {
  const { loggedInUsername, isBrand, isShopper, primaryGroup } = props;

  let pathToRedirectTo;
  if (isShopper) {
    pathToRedirectTo = '/shop/my/circles';
    if (primaryGroup) pathToRedirectTo = getLinkToShopForCuratorGroup(primaryGroup, { tab: 'latest' });
  } else if (isBrand) {
    pathToRedirectTo = `/talent`;
  } else if (loggedInUsername) {
    pathToRedirectTo = `/links`;
  } else {
    // Keep the search params
    const searchParams = new URLSearchParams(window.location.search);
    const search = searchParams.toString();
    pathToRedirectTo = `/home${search ? `?${search}` : ''}`;
  }

  return <Redirect to={{ pathname: pathToRedirectTo?.split('?')[0], search: pathToRedirectTo?.split('?')[1] || '' }} />;
};

const mapStateToProps = state => {
  const { user } = state;
  return {
    isShopper: isShopper(user),
    loggedInUsername: getUsername(user),
    isBrand: isBrand(user),
    primaryGroup: getDefaultCuratorGroup(user)
  };
};

export default connect(mapStateToProps, {})(RootRedirect);
